import React from "react";
import "./SelfIntroduction.css";

const SelfIntroduction = () => {
  const words1 = [
    "WEB", "DEVELOPMENT", "PROGRAMMING", "INTERNET", "COMPUTER", "DESIGNER",
    "DIGITAL", "HTML", "CODE", "STRATEGY", "SEO", "SOFTWARE", "BUSINESS",
    "AUGMENTED", "REALITY", "IOT", "EDGE", "COMPUTING", "BIG", "DATA","AUTOMATION", "SCRIPTING", "DEBUGGER", "COMPILER", "INTEGRATION",
    "DEPLOYMENT", "CONTAINERIZATION", "DOCKER", "KUBERNETES", "MICROSERVICES",
    "REST", "GRAPHQL", "JSON", "XML", "WEBHOOK", "AUTHENTICATION", "AUTHORIZATION",
    "SESSION", "COOKIE", "CACHE", "LOAD", "BALANCER", "REPOSITORY", "BRANCH",
    "MERGE", "PULL", "REQUEST", "CONTINUOUS", "DELIVERY", "PIPELINE", "TESTING",
    "UNIT", "INTEGRATION", "SYSTEM", "PERFORMANCE", "SCALABILITY", "RELIABILITY",
    "FAULT", "TOLERANCE", "DISASTER", "RECOVERY", "BACKUP", "RESTORE", "MONITORING",
    "LOGGING", "METRICS", "ALERTING", "INCIDENT", "RESPONSE", "SERVICE", "LEVEL",
    "OBJECTIVE", "AGREEMENT", "COMPLIANCE", "REGULATION", "PRIVACY", "GDPR",
    "GAME-DEVELOPMENT", "DEVOPS-ENGINEERING", "BLOCKCHAIN-TECHNOLOGY", "AUGMENTED-REALITY",
    "VIRTUAL-REALITY", "INTERNET-OF-THINGS", "EDGE-COMPUTING", "BIG-DATA", "DATA-ANALYTICS",
    "NATURAL-LANGUAGE-PROCESSING", "ROBOTICS", "AUTOMATION-ENGINEERING", "COMPUTER-VISION",
    "BIOINFORMATICS", "QUANTUM-COMPUTING", "SOFTWARE-TESTING", "CONTINUOUS-INTEGRATION",
    "CONTINUOUS-DELIVERY", "VERSION-CONTROL", "GIT-FLOW", "SCRUM-MASTER", "PRODUCT-OWNER",
    "PROJECT-MANAGEMENT", "AGILE-METHODOLOGY", "LEAN-STARTUP", "DESIGN-THINKING", "USER-RESEARCH",
    "PROTOTYPING", "WIREFRAMING", "INTERACTION-DESIGN", "VISUAL-DESIGN", "INFORMATION-ARCHITECTURE",
    "CONTENT-STRATEGY", "SEARCH-ENGINE-OPTIMIZATION", "SOCIAL-MEDIA-MARKETING", "DIGITAL-MARKETING",
    "EMAIL-MARKETING", "PAY-PER-CLICK", "AFFILIATE-MARKETING", "CONTENT-MANAGEMENT-SYSTEM",
    "WORDPRESS", "JOOMLA", "DRUPAL", "E-COMMERCE", "ONLINE-STORE", "SHOPIFY", "MAGENTO"
  ];

  const words2 = [
    "COMMUNICATION", "RESPONSIVE", "TECHNOLOGY", "APPLICATION", "DATABASE",
    "NETWORK", "SERVER", "CLIENT", "FRONTEND", "BACKEND", "FULLSTACK",
    "JAVASCRIPT", "PYTHON", "JAVA", "CSS", "UX",
    "WEB", "DEVELOPMENT", "PROGRAMMING", "INTERNET", "COMPUTER", "DESIGNER",
    "DIGITAL", "HTML", "CODE", "STRATEGY", "SEO", "SOFTWARE", "BUSINESS",
    "COMMUNICATION", "RESPONSIVE", "TECHNOLOGY","APPLICATION", "DATABASE", "NETWORK", "SERVER", "CLIENT", "FRONTEND",
    "BACKEND", "FULLSTACK", "JAVASCRIPT", "PYTHON", "JAVA", "CSS", "UX",
    "COMPUTER-SCIENCE", "WEB-DEVELOPMENT", "SOFTWARE-ENGINEERING", "DATA-SCIENCE",
    "MACHINE-LEARNING", "ARTIFICIAL-INTELLIGENCE", "CLOUD-COMPUTING", "CYBER-SECURITY",
    "NETWORK-ADMINISTRATION", "DATABASE-MANAGEMENT", "SYSTEM-ARCHITECTURE", "USER-EXPERIENCE",
    "USER-INTERFACE", "FRONT-END", "BACK-END", "FULL-STACK", "MOBILE-DEVELOPMENT",
    "GAME-DEVELOPMENT", "DEVOPS-ENGINEERING", "BLOCKCHAIN-TECHNOLOGY", "AUGMENTED-REALITY",
    "VIRTUAL-REALITY", "INTERNET-OF-THINGS", "EDGE-COMPUTING", "BIG-DATA", "DATA-ANALYTICS",
  ];

  const renderWords = (words, delayOffset) =>
    words.map((word, index) => (
      <span
        key={index}
        className="SelfIntroductionWord"
        style={{
          fontSize: `${Math.random() * 1.5 + 1}rem`,
          top: `${Math.random() * 105}vh`,
          animationDelay: `${Math.random() * 10 + delayOffset}s`,
          animationDuration: `${Math.random() * 5 + 10}s`,
        }}
      >
        {word}
      </span>
    ));

  return (
    <div className="section num1" id="self-introduction">
      {renderWords(words1, 0)}
      {renderWords(words2, 5)}
      <div class="SelfIntroductiocard-container">
        <img
          src="./attachment/Headshots.JPG"
          alt="Headshot"
          class="SelfIntroductiocard-image"
        />
        <div class="SelfIntroductiocard-content">
          <h1>Hello, I'm Zhihui Xu!</h1>
          <p>
            I am a passionate and dedicated software developer, currently open
            to work opportunities. With expertise in front-end and back-end
            development, I strive to create seamless, user-friendly
            applications. Let's build something amazing together!
          </p>
          <div class="SelfIntroductiocard-buttons">
            <a href="./attachment/resume2024.pdf" download>Download Resume</a>
            <a href="mailto:xuzhihuieateat@gmail.com">Contact Me</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelfIntroduction;
